const RAW_ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || null;

const getParsedRootDomain = () => {
  if (!RAW_ROOT_DOMAIN) return { rootHostname: null, port: null };
  const cleaned = RAW_ROOT_DOMAIN.replace(/^https?:\/\//i, "").replace(/\/.*$/, "");
  const parts = cleaned.split(":");
  const rootHostname = parts[0];
  const port = parts[1] || (window.location.port ? window.location.port : null);
  return { rootHostname, port };
};

export const buildSubdomainUrl = (subdomain, path = "/") => {
  const { rootHostname, port } = getParsedRootDomain();
  if (!rootHostname || !subdomain) {
    return path;
  }
  const formattedPath = path.startsWith("/") ? path : `/${path}`;
  const portSuffix = port ? `:${port}` : "";
  
  let targetHostname;
  if (rootHostname.includes("{subdomain}")) {
    targetHostname = rootHostname.replace("{subdomain}", subdomain);
  } else {
    targetHostname = `${subdomain}.${rootHostname}`;
  }

  return `${window.location.protocol}//${targetHostname}${portSuffix}${formattedPath}`;
};

export const isOnCorrectSubdomain = (subdomain) => {
  const { rootHostname } = getParsedRootDomain();
  if (!rootHostname || !subdomain) {
    return true;
  }
  
  let expectedHostname;
  if (rootHostname.includes("{subdomain}")) {
    expectedHostname = rootHostname.replace("{subdomain}", subdomain);
  } else {
    expectedHostname = `${subdomain}.${rootHostname}`;
  }
  
  return window.location.hostname.toLowerCase() === expectedHostname.toLowerCase();
};

export const redirectToOrganizationSubdomain = (subdomain, path = "/") => {
  const { rootHostname } = getParsedRootDomain();
  if (!rootHostname || !subdomain) {
    return;
  }
  const targetUrl = buildSubdomainUrl(subdomain, path);
  if (window.location.href !== targetUrl) {
    window.location.href = targetUrl;
  }
};

